/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export class NotificationInfo {
  numberOfErrors: number;
  numberOfInfos?: number;
  numberOfOks?: number;
  numberOfWarnings: number;
}
